export default defineNuxtRouteMiddleware( async (to, from) => {
    const {groupTypes} = await useGroupTypes();

    if (groupTypes.value.length == 0) {
        abortNavigation()
    }

    if (to.query.type == undefined) {
        return navigateTo( `${to.fullPath}/?type=${groupTypes.value[0].id}` )
    }
})